export default {
  label: "角色下拉框",
  type: "roleSelect",
  property: "",
  value: [],
  options: {
    placeholder: "请选择",
    padd: ""
  },
};
